import { Routes } from '@angular/router';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { HealthPageComponent } from './pages/health-page/health-page.component';
import { projectExistsGuard } from './core/guards/project-exists.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '404',
  },
  {
    path: '404',
    component: NotFoundPageComponent,
  },
  {
    path: 'health',
    component: HealthPageComponent,
  },
  {
    path: ':projectId',
    component: MainPageComponent,
    canActivate: [projectExistsGuard],
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
